import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useScreen } from '../../../utility/general';
import Card from '../../components/card';
const Wrapper = (props) => {
    return _jsx(_Fragment, { children: _jsx("div", { className: "d-flex h-100 align-items-center justify-content-center", children: props.children }) });
};
export default () => {
    const screen = useScreen();
    React.useEffect(() => {
        const channel = new BroadcastChannel('INTUIT');
        channel.postMessage('done');
        channel.close();
    }, []);
    if (screen.endsWith('/success')) {
        return _jsx(Wrapper, { children: _jsxs(Card, { title: "Intuit Connected", color: "success", children: [_jsx("p", { children: "Your Intuit connection was successful." }), _jsx("p", { children: "You may now close this tab." })] }) });
    }
    if (screen.endsWith('/error')) {
        return _jsx(Wrapper, { children: _jsx(Card, { title: "Intuit Connection Failed", color: "danger", children: _jsx("p", { children: "Please contact your system administrator." }) }) });
    }
    return _jsx(Wrapper, { children: _jsx(Card, { title: "Processing Intuit callback..." }) });
};
